<template>
    <div :class="$style['checkbox']">
        <input :class="$style['checkbox_input']"
               type="checkbox"
               :checked="value"
               :required="required"
               :name="name"
               :id="name"
               @change="$emit('change')">

        <label :for="name" :class="$style['checkbox__label']">
            <span :class="$style['checkbox__fake']">
                <svg width="11"
                     height="8"
                     viewBox="0 0 11 8"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 3L4.5 6.5L10 1" stroke="#B98F4F" stroke-width="2"/>
                </svg>
            </span>
            <span :class="$style['checkbox__text']"><slot></slot></span>
        </label>
    </div>
</template>

<script>
    export default {
        props: ['name', 'value', 'required'],

        model: {
            prop: 'value',
            event: 'change'
        }
    }
</script>

<style lang="scss" module>
    $checkbox-color: $brand-dark-brown;
    $checkbox-link-bdr: rgba($brand-dark-brown, 0.3);

    .checkbox {
        position: relative;

        &.is-error {
            .checkbox__fake {
                border-color: $brand-red;
            }
        }
    }

    .checkbox_input {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: z(delete);
        opacity: 0;

        &:checked + .checkbox__label {
            .checkbox__fake {
                svg {
                    transition-property: stroke-dashoffset;
                    transition-delay: 0s;
                    stroke-dashoffset: 0;
                    opacity: 1;
                }
            }
        }
    }

    .checkbox__label {
        display: flex;
        cursor: pointer;

        &:hover {
            .checkbox__fake {
                // Media
                @media #{$laptop} {
                    border-color: rgba($brand-accent, 0.6);
                }
            }
        }
    }

    .checkbox__fake {
        @include scale(width, 20, 20, 24);
        @include scale(height, 20, 20, 24);
        @include scale(margin-right, 16, 16, 16);
        @include transition(background, border-color);
        position: relative;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba($brand-dark-brown, 0.3);
        background-color: transparent;

        svg {
            @include scale(width, 11, 11, 11);
            height: auto;
            stroke: $white;
            stroke-width: 2;
            stroke-dasharray: 20;
            stroke-dashoffset: 20;
            opacity: 0;
            transition: stroke-dashoffset 0.3s ease-in 0.2s, opacity 0.2s ease-out 0s;

        }
    }

    .checkbox__text {
        @include font-size(p3);
        display: block;
        color: $checkbox-color;
        transition: color 0.2s ease-out;

        a {
            @include transition(color);
            @include scale(padding-bottom, 2, 2, 2);
            color: inherit;
            border-bottom: 1px solid $checkbox-link-bdr;

            &:hover {
                // Media
                @media #{$laptop} {
                    color: $brand-accent;
                    border-bottom: 1px solid rgba($brand-accent, 0.3);
                }
            }
        }
    }
</style>
